/* eslint-disable */
import React, { useState } from "react";
import Body from "./Body";
import WorkshopStore from "../../../../store/Operational/Workshop/Workshop.store";

const Dashboard = () => {
  const [overViewCardData, setOverViewCardData] = useState([
    {
      title: "Maintenance",
      presentCount: "4",
      totalCount: "2",
      // cardType: "regular",
      bgColor: "#EEEAFF",
    },
    {
      title: "Tenders",
      presentCount: "12",
      totalCount: "2",
      cardType: "regular",
      bgColor: "#FFD5001F",
    },
  ]);
  //   graph data
  const [workshopBudgetGraphData, setWorkshopBudgetGraphData] = useState([
    { name: "Jan", profit: 20000 },
    { name: "Feb", profit: 95000 },
    { name: "Mar", profit: 70000 },
    { name: "Apr", profit: 55000 },
    { name: "May", profit: 30000 },
    { name: "June", profit: 75000 },
    { name: "July", profit: 82000 },
    { name: "Aug", profit: 12000 },
    { name: "Sept", profit: 50000 },
    { name: "Oct", profit: 68000 },
    { name: "Nov", profit: 25000 },
    { name: "Dec", profit: 36000 },
  ]);

  const [tenderHistory, setTenderHistory] = useState([
    {
      id: "a1b2",
      title: "Garden grass chopping",
      vendor: "Local grass cutter",
      date: "23 May, 2025",
      status: "active",
    },
    {
      id: "c3d4",
      title: "Bathroom cleaning",
      vendor: "Local cleaners",
      date: "23 May, 2025",
      status: "active",
    },
    {
      id: "e5f6",
      title: "Bathroom cleaning",
      vendor: "Local cleaners",
      date: "23 May, 2025",
      status: "completed",
    },
    {
      id: "g7h8",
      title: "School compound painting",
      vendor: "BrightCoat Ltd.",
      date: "22 May, 2025",
      status: "completed",
    },
    {
      id: "i9j0",
      title: "Ceiling paneling",
      vendor: "TopDecors",
      date: "21 May, 2025",
      status: "active",
    },
    {
      id: "k1l2",
      title: "Outdoor LED lighting",
      vendor: "ElectroServe",
      date: "20 May, 2025",
      status: "completed",
    },
    {
      id: "m3n4",
      title: "Library woodwork",
      vendor: "CraftMasters",
      date: "19 May, 2025",
      status: "active",
    },
    {
      id: "o5p6",
      title: "Classroom renovation",
      vendor: "UrbanBuilders",
      date: "18 May, 2025",
      status: "completed",
    },
    {
      id: "q7r8",
      title: "CCTV system upgrade",
      vendor: "SecureTech",
      date: "17 May, 2025",
      status: "active",
    },
    {
      id: "s9t0",
      title: "Roof structure maintenance",
      vendor: "BuildWell",
      date: "16 May, 2025",
      status: "completed",
    },
    {
      id: "u1v2",
      title: "Car parking expansion",
      vendor: "MetroConstruct",
      date: "15 May, 2025",
      status: "active",
    },
    {
      id: "w3x4",
      title: "School gate replacement",
      vendor: "IronBuilds",
      date: "14 May, 2025",
      status: "completed",
    },
    {
      id: "y5z6",
      title: "Drainage upgrade",
      vendor: "PipeFixers",
      date: "13 May, 2025",
      status: "active",
    },
    {
      id: "a7b8",
      title: "Main hall re-flooring",
      vendor: "Shiny Floors",
      date: "12 May, 2025",
      status: "completed",
    },
    {
      id: "c9d0",
      title: "Plumbing retender",
      vendor: "HydroWorks",
      date: "11 May, 2025",
      status: "completed",
    },
    {
      id: "e1f3",
      title: "Internet infrastructure",
      vendor: "FiberConnect",
      date: "10 May, 2025",
      status: "active",
    },
    {
      id: "g4h5",
      title: "Paint touch-up",
      vendor: "UrbanColor",
      date: "09 May, 2025",
      status: "completed",
    },
    {
      id: "i6j7",
      title: "Teacher’s lounge redesign",
      vendor: "DesignFlow",
      date: "08 May, 2025",
      status: "active",
    },
    {
      id: "k8l9",
      title: "Stage lighting system",
      vendor: "EventLights",
      date: "07 May, 2025",
      status: "completed",
    },
    {
      id: "m0n1",
      title: "Security fencing",
      vendor: "GuardLine Ltd.",
      date: "06 May, 2025",
      status: "completed",
    },
    {
      id: "o2p3",
      title: "Bathroom plumbing fix",
      vendor: "PipePros",
      date: "05 May, 2025",
      status: "active",
    },
    {
      id: "q4r5",
      title: "Solar panel maintenance",
      vendor: "SunVolt Systems",
      date: "04 May, 2025",
      status: "completed",
    },
    {
      id: "s6t7",
      title: "Ground leveling",
      vendor: "EarthMover Inc.",
      date: "03 May, 2025",
      status: "active",
    },
    {
      id: "u8v9",
      title: "Computer lab rewire",
      vendor: "TechLine Services",
      date: "02 May, 2025",
      status: "completed",
    },
  ]);

  const [maintenanceHistory, setMaintenanceHistory] = useState([
    {
      id: "a1f3",
      title: "Garden grass chopping",
      vendor: "Local grass cutter",
      date: "23 May, 2025",
      status: "active",
    },
    {
      id: "b4e2",
      title: "Bathroom cleaning",
      vendor: "Local cleaners",
      date: "23 May, 2025",
      status: "active",
    },
    {
      id: "c5d8",
      title: "Bathroom cleaning",
      vendor: "Local cleaners",
      date: "23 May, 2025",
      status: "completed",
    },
    {
      id: "d9a1",
      title: "Window glass repair",
      vendor: "UrbanFix Team",
      date: "22 May, 2025",
      status: "active",
    },
    {
      id: "e2b3",
      title: "Lighting fixture replacement",
      vendor: "BrightElec",
      date: "21 May, 2025",
      status: "completed",
    },
    {
      id: "f7c6",
      title: "Pipe leakage fix",
      vendor: "HydroFlow",
      date: "20 May, 2025",
      status: "completed",
    },
    {
      id: "g8d7",
      title: "Roof waterproofing",
      vendor: "TopSeal Experts",
      date: "19 May, 2025",
      status: "active",
    },
    {
      id: "h9e4",
      title: "Elevator maintenance",
      vendor: "LiftSafe",
      date: "18 May, 2025",
      status: "completed",
    },
    {
      id: "i1a5",
      title: "Security system check",
      vendor: "SafeHome",
      date: "17 May, 2025",
      status: "active",
    },
    {
      id: "j3b2",
      title: "Painting lobby area",
      vendor: "ColorCoat",
      date: "16 May, 2025",
      status: "completed",
    },
    {
      id: "k6c3",
      title: "AC filter cleaning",
      vendor: "CoolServ",
      date: "15 May, 2025",
      status: "active",
    },
    {
      id: "l7d8",
      title: "Floor tile polishing",
      vendor: "ShineMates",
      date: "14 May, 2025",
      status: "completed",
    },
    {
      id: "m8e9",
      title: "Garage door repair",
      vendor: "FixItNow",
      date: "13 May, 2025",
      status: "active",
    },
    {
      id: "n9f1",
      title: "Drainage inspection",
      vendor: "Urban Plumbers",
      date: "12 May, 2025",
      status: "completed",
    },
    {
      id: "o1g2",
      title: "Fire safety inspection",
      vendor: "FlameGuard",
      date: "11 May, 2025",
      status: "completed",
    },
    {
      id: "p3h3",
      title: "Garden fence fixing",
      vendor: "FenceWorks",
      date: "10 May, 2025",
      status: "active",
    },
    {
      id: "q5i4",
      title: "Lobby cleaning",
      vendor: "SparkleCleaners",
      date: "09 May, 2025",
      status: "completed",
    },
    {
      id: "r6j5",
      title: "Basement water removal",
      vendor: "DryQuick",
      date: "08 May, 2025",
      status: "completed",
    },
    {
      id: "s7k6",
      title: "Intercom system check",
      vendor: "ComNet",
      date: "07 May, 2025",
      status: "active",
    },
    {
      id: "t8l7",
      title: "Parking repainting",
      vendor: "StripePro",
      date: "06 May, 2025",
      status: "completed",
    },
    {
      id: "u9m8",
      title: "Fence painting",
      vendor: "FenceArt",
      date: "05 May, 2025",
      status: "completed",
    },
    {
      id: "v1n9",
      title: "Staircase handrail fix",
      vendor: "HandyHub",
      date: "04 May, 2025",
      status: "active",
    },
    {
      id: "w2o1",
      title: "Trash bin replacement",
      vendor: "CleanTown",
      date: "03 May, 2025",
      status: "completed",
    },
    {
      id: "x3p2",
      title: "Sewage treatment check",
      vendor: "EcoDrain",
      date: "02 May, 2025",
      status: "active",
    },
    {
      id: "y4q3",
      title: "Main gate automation",
      vendor: "AutoEntry",
      date: "01 May, 2025",
      status: "completed",
    },
  ]);

  const [workShopBudgetGraphBtn, setWorkShopBudgetGraphBtn] = useState(false);
  const [maintenanceWorkProgressHistory, setMaintenanceWorkProgressHistory] =
    useState([
      {
        id: "p1",
        name: "Garden grass chopping",
        budget: 12000,
        deadline: "30 May, 2025",
      },
      {
        id: "p2",
        name: "Road maintenance",
        budget: 12000,
        deadline: "30 May, 2025",
      },
      {
        id: "p3",
        name: "Bathroom cleaning",
        budget: 100000,
        deadline: "30 May, 2025",
      },
      {
        id: "p4",
        name: "Campus cleaning",
        budget: 23000,
        deadline: "30 May, 2025",
      },
      {
        id: "p5",
        name: "Playground leveling",
        budget: 18000,
        deadline: "01 June, 2025",
      },
      {
        id: "p6",
        name: "Ceiling repair",
        budget: 45000,
        deadline: "02 June, 2025",
      },
      {
        id: "p7",
        name: "Fence painting",
        budget: 9500,
        deadline: "03 June, 2025",
      },
      {
        id: "p8",
        name: "Drainage inspection",
        budget: 27000,
        deadline: "04 June, 2025",
      },
      {
        id: "p9",
        name: "Library carpet change",
        budget: 33000,
        deadline: "05 June, 2025",
      },
      {
        id: "p10",
        name: "CCTV installation",
        budget: 120000,
        deadline: "06 June, 2025",
      },
      {
        id: "p11",
        name: "Tree trimming",
        budget: 8000,
        deadline: "07 June, 2025",
      },
      {
        id: "p12",
        name: "Water tank cleaning",
        budget: 15500,
        deadline: "08 June, 2025",
      },
      {
        id: "p13",
        name: "Roof waterproofing",
        budget: 72000,
        deadline: "09 June, 2025",
      },
      {
        id: "p14",
        name: "Parking line marking",
        budget: 11000,
        deadline: "10 June, 2025",
      },
      {
        id: "p15",
        name: "Auditorium cleaning",
        budget: 28000,
        deadline: "11 June, 2025",
      },
    ]);
  const [tendersInProgress, setTendersInProgress] = useState([
    {
      id: "t1",
      contractor: "Tansufi architect pvt. ltd.",
      description: "New hostel boys building",
      budget: 350000,
      deadline: "2 May, 2025",
    },
    {
      id: "t2",
      contractor: "Tansufi architect pvt. ltd.",
      description: "New Class building for 11 & 12 science",
      budget: 552000,
      deadline: "2 May, 2025",
    },
    {
      id: "t3",
      contractor: "BuildCon Engineers",
      description: "Multipurpose hall extension",
      budget: 430000,
      deadline: "5 May, 2025",
    },
    {
      id: "t4",
      contractor: "Rising Infra Projects",
      description: "Administrative block renovation",
      budget: 275000,
      deadline: "8 May, 2025",
    },
    {
      id: "t5",
      contractor: "GreenField Developers",
      description: "Main entrance landscape design",
      budget: 190000,
      deadline: "10 May, 2025",
    },
    {
      id: "t6",
      contractor: "MegaTech Contractors",
      description: "Auditorium soundproofing",
      budget: 310000,
      deadline: "12 May, 2025",
    },
    {
      id: "t7",
      contractor: "Urban Construct Pvt. Ltd.",
      description: "Library modernization",
      budget: 450000,
      deadline: "14 May, 2025",
    },
    {
      id: "t8",
      contractor: "Structura India",
      description: "New physics laboratory setup",
      budget: 225000,
      deadline: "16 May, 2025",
    },
    {
      id: "t9",
      contractor: "OmniBuild Engineers",
      description: "Staff quarters refurbishment",
      budget: 320000,
      deadline: "18 May, 2025",
    },
    {
      id: "t10",
      contractor: "Vision Planners",
      description: "Campus boundary wall upgrade",
      budget: 165000,
      deadline: "20 May, 2025",
    },
    {
      id: "t11",
      contractor: "Infinity Constructions",
      description: "Cafeteria expansion project",
      budget: 295000,
      deadline: "22 May, 2025",
    },
    {
      id: "t12",
      contractor: "Pioneer Infra Group",
      description: "Drainage and plumbing overhaul",
      budget: 375000,
      deadline: "24 May, 2025",
    },
    {
      id: "t13",
      contractor: "Zenith Design Studio",
      description: "Interior design for admin block",
      budget: 205000,
      deadline: "26 May, 2025",
    },
    {
      id: "t14",
      contractor: "EcoSmart Builders",
      description: "Rainwater harvesting system",
      budget: 140000,
      deadline: "28 May, 2025",
    },
    {
      id: "t15",
      contractor: "ModernEdge Contractors",
      description: "Security camera installation",
      budget: 185000,
      deadline: "30 May, 2025",
    },
    {
      id: "t16",
      contractor: "Tansufi architect pvt. ltd.",
      description: "New chemistry lab building",
      budget: 500000,
      deadline: "1 June, 2025",
    },
    {
      id: "t17",
      contractor: "AlphaBuild Systems",
      description: "Electrical wiring upgrade",
      budget: 245000,
      deadline: "3 June, 2025",
    },
    {
      id: "t18",
      contractor: "Evolve Engineering Works",
      description: "AC installation in classrooms",
      budget: 198000,
      deadline: "5 June, 2025",
    },
    {
      id: "t19",
      contractor: "NextGen Developers",
      description: "Green building certification",
      budget: 275000,
      deadline: "7 June, 2025",
    },
    {
      id: "t20",
      contractor: "UrbanCraft Solutions",
      description: "Walkway tiling and roofing",
      budget: 310000,
      deadline: "9 June, 2025",
    },
  ]);

  // Add workshop modal
  const [addWorkshopModal, setAddWorkshopModal] = useState(false);
  const [maintenanceViewerModal, setMaintenanceViewerModal] = useState(false);
  const [tenderViewerModal, setTenderViewerModal] = useState(false);

  const [addWorkshopFormSelection, setAddWorkshopFormSelection] =
    useState("Maintenance");

  const {
    setMaintenceViewerData,
    setTenderViewerData,
    maintenanceViewerData,
    tenderViewerData,
  } = WorkshopStore();

  const _this = {
    overViewCardData,
    workShopBudgetGraphBtn,
    setWorkShopBudgetGraphBtn,
    // graph data
    workshopBudgetGraphData,
    setWorkshopBudgetGraphData,
    maintenanceHistory,
    setMaintenanceHistory,
    tenderHistory,
    setTenderHistory,
    maintenanceWorkProgressHistory,
    setMaintenanceWorkProgressHistory,
    tendersInProgress,
    setTendersInProgress,
    addWorkshopModal,
    setAddWorkshopModal,
    addWorkshopFormSelection,
    setAddWorkshopFormSelection,
    maintenanceViewerModal,
    setMaintenanceViewerModal,
    // stores states
    setMaintenceViewerData,
    setTenderViewerData,
    maintenanceViewerData,
    tenderViewerData,
    tenderViewerModal,
    setTenderViewerModal,
  };

  return <Body {..._this} />;
};

export default Dashboard;
